<template>
  <div>
    <div v-if="label" class="text-base font-normal mb-2 flex w-auto items-start">
      {{ label }}
      <span v-if="isRequired" class="text-velux-red ml-0.5">*</span>
    </div>
    <div v-if="hasUploadedFile" class="block mb-4 text-lg bold" v-on:click="remove">
      <i class="far fa-times cursor-pointer mr-2"></i>
      {{ $store.state.attachment.name }}
    </div>
    <label class="bg-velux-white
                  md:text-xl
                  py-3.5
                  px-7
                  md:py-3
                  font-bold
                  block
                  md:inline-block
                  border-2
                  text-center
                  transition-colors
                  hover:bg-velux-grey-100
                  cursor-pointer" 
            :for="id">
          <slot></slot>
    </label>
    <input type="file" :required="isRequired" v-on:change="handleFileUpload($event)" :name="name" ref="file" :id="id" class="fixed bottom-full" />
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: {
    errorMessage: String,
    isRequired: {
      type: Boolean,
      default: false
    },
    label: String,
    id: String,
    name: String
  },
  mounted() {
    this.emitValidation();
  },
  methods: {
    ...mapMutations([
      "saveFile",
      "removeFile"
    ]),
    handleFileUpload($event) {
      let fileData = $event.target.files[0];

      if (fileData) {
        this.saveFile( {
          "name": fileData.name,
          "binary": fileData
        });

        this.emitValidation();
      }
    },
    remove() {
      this.removeFile();
      this.$refs.file.value = null;

      this.emitValidation();
    },
    emitValidation() {
      let validity = !this.hasUploadedFile && this.isRequired;
      this.$emit("inputWasChanged", validity);
    }
  },
  computed: {
    hasUploadedFile() {
      return Object.keys(this.$store.state.attachment).length > 0;
    }
  }
};
</script>